import { Grid } from "@material-ui/core";
import React from "react";
import { BooleanInput } from "react-admin";

const DaysOfWeekInput = () => (
  <>
    <Grid item xs={2}>
      <BooleanInput label="Monday" source="isMonday" defaultValue={true} />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Tuesday" source="isTuesday" defaultValue={true} />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput
        label="Wednesday"
        source="isWednesday"
        defaultValue={true}
      />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Thursday" source="isThursday" defaultValue={true} />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Friday" source="isFriday" defaultValue={true} />
    </Grid>
  </>
);

export default DaysOfWeekInput;
